// assets/wishlist.js
// Simple localStorage-based wishlist for Dawn

const WISHLIST_KEY = 'wishlist_products';

// Get wishlist array from localStorage
function getWishlist() {
  const raw = window.localStorage.getItem(WISHLIST_KEY);
  if (!raw) return [];
  try {
    return JSON.parse(raw);
  } catch (e) {
    return [];
  }
}

// Save wishlist array to localStorage
function saveWishlist(list) {
  window.localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
}

// Update all buttons + header count based on current wishlist
function refreshWishlistUI() {
  const ids = getWishlist();

  // Update buttons (product cards + product page)
  const buttons = document.querySelectorAll('[data-wishlist-button]');
  buttons.forEach((btn) => {
    const productId = btn.getAttribute('data-product-id');
    if (!productId) return;

    const inWishlist = ids.includes(productId.toString());
    btn.classList.toggle('is-active', inWishlist);
    btn.setAttribute('aria-pressed', inWishlist ? 'true' : 'false');
  });

  // Update count in header
 const countElm = document.querySelector('[data-wishlist-count]');
const bubble = countElm ? countElm.closest('.cart-count-bubble') : null;

if (countElm) {
  countElm.textContent = ids.length.toString();

  if (bubble) {
    if (ids.length > 0) {
      bubble.style.display = '';
    } else {
      bubble.style.display = 'none';
    }
  }
}

}

// Toggle product in wishlist and refresh UI
function toggleWishlist(id) {
  if (!id) return;

  const list = getWishlist();
  const idStr = id.toString();
  const index = list.indexOf(idStr);

  if (index === -1) {
    list.push(idStr);
  } else {
    list.splice(index, 1);
  }

  saveWishlist(list);
  refreshWishlistUI();
}

// ✅ Event delegation: works for dynamically loaded sections too
document.addEventListener('click', function (e) {
  const btn = e.target.closest('[data-wishlist-button]');
  if (!btn) return;

  e.preventDefault();

  const productId = btn.getAttribute('data-product-id');
  toggleWishlist(productId);
});

// Initial UI on page load
document.addEventListener('DOMContentLoaded', function () {
  refreshWishlistUI();
});
